import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './resources-list.css';

class ResourcesList extends PureComponent
{
  static propTypes = {
    resources: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedResource: PropTypes.shape({}),
    onSelect: PropTypes.func.isRequired,
    onInsert: PropTypes.func.isRequired,
    onChangeLocation: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired
  };

  static defaultProps = {
    selectedResource: null
  };

  static getDerivedStateFromProps(nextProps, prevState)
  {
    const { selectedResource, resources } = nextProps;
    const { selectedIndex } = prevState;

    if (selectedResource && selectedResource !== resources[selectedIndex])
    {
      return {
        ...prevState,
        selectedIndex: resources.indexOf(selectedResource)
      };
    }

    return prevState;
  };

  constructor(props)
  {
    super(props);
    this.state = { selectedIndex: null };
  }

  handleChangeLocation = (index) =>
  {
    const { onChangeLocation, resources } = this.props;
    onChangeLocation(resources[index], index);
  };

  handleSelect = (index) =>
  {
    const { onSelect, resources } = this.props;
    const { selectedIndex } = this.state;

    if (selectedIndex === index)
    {
      this.setState({ selectedIndex: null });
      onSelect(null, null);
    }
    else
    {
      this.setState({ selectedIndex: index });
      onSelect(resources[index], index);
    }
  };

  render()
  {
    const { resources, children, onInsert } = this.props;
    const { selectedIndex } = this.state;

    return (
      <div className="resource-dialog__resources-list">
        {children({
          resources,
          selectedIndex,
          onInsert,
          onSelect: this.handleSelect,
          onChangeLocation: this.handleChangeLocation
        })}
      </div>
    );
  }
}

export default ResourcesList;